query ListMerchShops {
  shops: StreamToolsListMerchShops {
    shop
    appKey
    accountId
    ownerEmail
    broadcasterId
    version
    lastWebhookAt
    registeredAt
    productCount
    connectionStatus
    uninstalledAt
    source
  }
}
